import { Link } from 'react-router-dom'
import { HelixBand } from './Helix'
import { Wordmark } from './SiteNav'

export default function SiteFooter() {
  return (
    <footer className="relative" style={{ backgroundColor: '#1E3018' }}>
      <div className="container-hx pt-6">
        <HelixBand dark height={44} turns={10} className="opacity-70" />
      </div>
      <div className="container-hx grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Wordmark light />
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-[#F3F5F1]/60">
            Independent, non-GMO maize genetics for Southern Africa. 25 years. 100+ lines. One
            complete breeding program.
          </p>
        </div>
        {[
          {
            h: 'Program',
            items: [
              ['Hybrids', '/hybrids'],
              ['Breeding Program', '/breeding-program'],
              ['About', '/about'],
            ],
          },
          {
            h: 'Company',
            items: [
              ['Partners', '/partners'],
              ['Work With Us', '/#contact'],
            ],
          },
        ].map((col) => (
          <div key={col.h}>
            <div className="font-mono-data text-[11px] uppercase tracking-[0.22em] text-[#8BA872]">
              {col.h}
            </div>
            <ul className="mt-5 space-y-3">
              {col.items.map(([label, to]) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-sm font-light text-[#F3F5F1]/70 transition-colors hover:text-[#F3F5F1]"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <div className="font-mono-data text-[11px] uppercase tracking-[0.22em] text-[#8BA872]">
            Direct
          </div>
          <ul className="mt-5 space-y-3 text-sm font-light text-[#F3F5F1]/70">
            <li>
              <a href="mailto:admin@hylix.co.za" className="transition-colors hover:text-[#F3F5F1]">
                admin@hylix.co.za
              </a>
            </li>
            <li>hylix.co.za</li>
            <li>South Africa</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F3F5F1]/10">
        <div className="container-hx flex flex-col gap-2 py-6 text-[11px] font-light tracking-wide text-[#F3F5F1]/40 md:flex-row md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} Hylix Genetics. All rights reserved.</span>
          <span className="font-mono-data uppercase tracking-[0.18em]">
            Conventional breeding · Zero GMO
          </span>
        </div>
      </div>
    </footer>
  )
}
